var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-user-agreement",
      style: `paddingTop:${_vm.barHeight}px`,
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "title" }, [_vm._v("JoyChat Terms of Use")]),
      _c("span", [_vm._v("Effective Date: 2024/2/1")]),
      _c("div", [_vm._v("Contact us：joychat9527@gmail.com")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v("Non-binding summary of ToS"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " This is an overview of some of the important rights and obligations as set out in the Articles below. It serves as a quick reference, which means that the summary is not meant to be complete and that only the numbered Articles of these Terms of Use below are legally binding. Therefore, please read these Terms of Use thoroughly for a full understanding of your rights and obligations. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [_vm._v("Your rights:")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "· We provide you a license to install the App on your Device for your own personal use;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· You may use the App if you are 18 years or older and on the further conditions mentioned in Article 2.1;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· You may terminate your use of the Service and the App at any time by deleting your account;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· You may purchase Premium Services or paid Content. Your rights related to Premium Services or paid Content are set out in Article 7."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [_vm._v("Your obligations:")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " · While using the App, you must comply with the Community Guidelines. You may not use the App for illegal purposes or for the purpose of harming the App or its users in any way. "
        ),
      ]),
      _c("div", [
        _vm._v(
          " · You may not mislead other users of the App, which among other things means that you may not use fake profiles or impersonate others. Although it is prohibited, you should be aware that other users may attempt to mislead you by using fake profiles or by impersonating others; "
        ),
      ]),
      _c("div", [
        _vm._v(
          "· You are responsible for the Content that you share. Other users are responsible for the Content they share in the same way. We do not endorse any Content."
        ),
      ]),
      _c("div", [
        _vm._v(
          "· You are responsible for reading our Privacy Policy and understanding its terms."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "The following subjects will be discussed in these Terms of Use:"
        ),
      ]),
      _c("div", [_vm._v("· 1.Introduction")]),
      _c("div", [_vm._v("· 2.Eligibility")]),
      _c("div", [_vm._v("· 3.Description of the App and the Services")]),
      _c("div", [_vm._v("· 4.Intellectual Property")]),
      _c("div", [_vm._v("· 5.Content and Behaviour")]),
      _c("div", [_vm._v("· 6.Your Data")]),
      _c("div", [_vm._v("· 7.Premium Services and paid Content")]),
      _c("div", [_vm._v("· 8.Third Parties")]),
      _c("div", [_vm._v("· 9.Termination")]),
      _c("div", [_vm._v("· 10.Liability")]),
      _c("div", [_vm._v("· 11.Indemnification")]),
      _c("div", [_vm._v("· 12.Warranties")]),
      _c("div", [_vm._v("· 13.General")]),
      _c("div", { staticClass: "tit" }, [_vm._v("1. Introduction")]),
      _c("div", [
        _c("i", { staticClass: "num" }, [_vm._v("1.1")]),
        _vm._v(
          " Please read carefully the following provisions of these Terms and Conditions of Use (“Terms”) to ensure that you understand its contents before you use our software programs and related documentation (the “App”) and any of the services enabled by the App (the “Services”). (App and Services are referred to together as “Products”) "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("1.2")]),
        _vm._v(
          " Should you require any further information or technical support, please send an email to joychat9527@gmail.com."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("1.3")]),
        _vm._v(
          " You may use the Products only in compliance with these Terms and all applicable laws, rules and regulations and you may only use the Products if you agree to form a binding contract with us. These Terms are a legal agreement made between you and Liangziqianxun Technology or one of its affiliates (“we” or “JoyChat”), a company with its registered address at Wuhan (“the App”,”we”, “us” or “our”), regarding the use of the Products on your device. By registering yourself to use the Products you enter into these Terms with us. If at any time you do not agree to these Terms or our privacy policy, please stop using the Products. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("1.4")]),
        _vm._v(
          " Our Products evolve constantly. Consequently, our Products may change from time to time if we deem it necessary to improve the performance or security of our Products, to change our features or composition, to comply with applicable laws and regulations, or to prevent illegal activities on or abuse of our Products. In these cases, such change will be notified to you in advance, unless otherwise required by law or for maintenance of service security or other urgent circumstances occur. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We may (i) stop (permanently or temporarily) providing the Products or any features within the Products to you or to users generally; (ii) retain the right to create limits on your use and storage within our Products; (iii) remove or refuse to distribute your Content on the Services, limit distribution or visibility of any Content, suspend or terminate users’ account, and reclaim usernames without liability to you in accordance with these Terms. We may offer certain Products or features for a fee; by paying for or using one of these Products, you agree to any additional terms applicable to that Product. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("1.5")]),
        _vm._v(
          " We may amend, supplement or replace the conditions of these Terms as described in Article 13.5 below."
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("2. Eligibility")]),
      _c("div", [
        _c("i", { staticClass: "num" }, [_vm._v("2.1")]),
        _vm._v(
          " You may only use the App and/or Services if you are eighteen (18) years of age or older and not barred from using the App or receiving the Services under the laws of the applicable jurisdiction, and have the legal capacity and authority to enter into this Agreement and form a binding contract with us; "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You may not use the Products if you are under 18. You may not use the Products if you have been a convicted sex offender, accused or convicted of any human trafficking or modern slavery crime; lacking legal capacity; or legally prohibited, in any way, to use the Products by the laws of the country you reside in; "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          ' You may not use the Products if you are located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a "terrorist supporting" country; and if you are listed on any U.S. Government list of prohibited or restricted parties. '
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("2.2")]),
        _vm._v(
          " Any use, registration or access to the Products by a person who does not fulfill the eligibility requirements above is unauthorized, unlicensed, and in violation of these Terms. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("2.3")]),
        _vm._v(
          " You hereby affirm that you fully understand these Terms, and represent and warrant that you are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations and warranties set forth in these Terms, and to abide by and comply with the terms and conditions of these Terms. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("2.4")]),
        _vm._v(
          " We may terminate your account, delete any Content or information that you have posted on the Services, and/or prohibit you from using or accessing the Products (or any part of the Services) if we do believe that you do not fulfill the eligibility requirements above. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [
        _vm._v("3. Description of the App and the Services"),
      ]),
      _c("div", [
        _vm._v(
          " Our aim is to give people the opportunity and ability to connect with others around the world with real time connections and meaningful conversations. To support this aim we provide Products, (Apps and Services) as described below. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Connect and communicate with people and friends effectively. We help you connect and find people and friends across our platforms. We use the data we have to help make personalised relevant and meaningful connections and conversations. We use and have developed technologies and designed our systems so that your experience is consistent and seamless to help you connect and share, through live video, chat, text, sharing photos, interests, videos and conversation. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Research ways to make our Products and Apps better. We constantly look to improve our Products and carry out research in order to develop and test our Products and provide new ones. This includes analyzing data about our users and understanding how they use our Products. This includes developing advanced technologies such as automated method so that our Products can be used safely – for example to improve our ability to detect and remove illegal content. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Safety. Safety on our site is very important to us. We deploy technical systems supported by dedicated teams to detect misuse of our Products. Where we learn of improper content or conduct, we take action, including, but not limited to blocking or disabling accounts. We share data with our affiliates and third parties when we detect improper content or conduct. You understand and agree that we may monitor or review any and all Content that you transmit or share through our Products, including your video chat screen, only for safety and security reasons. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Global access to our Products. To operate our Products on a global basis we need to store and distribute data around the world, including outside your country of residence. This infrastructure includes third parties who help support our Products as well as our Affiliates. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("3.1 Your Use of your Device"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You warrant that you own the Device to which you are downloading the App, or that you have the legal right to control the use of that Device. You further agree to ensure that any other person whom you permit to use the Products will do so in accordance with these Terms. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("3.2 New Versions of the App"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We can choose to add additional features or functions, or to modify the Products in any other way, for instance to improve performance, enhance functionality, address changes to the operating system or address security issues. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("3.3")]),
        _vm._v(
          " You may have to agree to a renewed version of the Terms in the event you want to download, install or use any additional features or functions or any modifications, updates or new versions of the App. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("3.4")]),
        _vm._v(
          " You acknowledge that we may automatically issue any additional features, functions, modifications, updates or upgraded versions of the App and, accordingly, may modify, update or upgrade the version of the App that you are using or have installed on your Device. You hereby agree that your Device may automatically request and/or receive such modifications, upgrades or updates. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("3.5")]),
        _vm._v(
          " We have no obligation to make available to you any additional features or functions or any modifications, updates, support, maintenance or subsequent versions of the App or any of the Services. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _c("i", { staticClass: "num" }, [_vm._v("3.6")]),
        _vm._v(" No Access to Emergency Services"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " The Products are not intended to replace phone lines and as such are not built to support or carry emergency calls to any type of hospitals, law enforcement agencies, medical care units or any other kind of services that connect a user to emergency services personnel or public safety answering points pursuant to applicable local and or national regulatory requirements (“Emergency Services”). "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("3.7")]),
        _vm._v(
          " There are important differences between traditional telephone services and the Products. You acknowledge and agree that:"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· We are not required to offer access to Emergency Services under any applicable local and/or national rules, regulations or law;"
        ),
      ]),
      _c("div", [
        _vm._v(
          " · it is your responsibility to purchase, separately from the App, traditional wireless (cellular) or fixed line telephone services that offer access to Emergency Services, "
        ),
      ]),
      _c("div", [
        _vm._v(
          "· We are not a replacement for your primary telephone service."
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _c("i", { staticClass: "num" }, [_vm._v("3.8")]),
        _vm._v(" Prevention of Unauthorized Use"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We reserve the right to exercise whatever lawful means we deems necessary to prevent the unauthorized use of the App or Services, including, but not limited to, technological barriers, IP mapping, and directly contacting your wireless (cellular) carrier or device manufacturer regarding such unauthorized use. If any personal data is processed for this purpose, this shall be in accordance with our Privacy Policy. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("4. Intellectual Property")]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("4.1 Ownership")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Our Products are protected by local copyright laws and international copyright treaties, as well as other intellectual property laws and treaties. Our Products include trade secrets and information that is confidential and proprietary to us and you agree to take all necessary actions to protect the confidentiality of such information. All ownership rights in the Products, including any related documentation, graphic, image, illustration, design, icon, photo, and other related phrases provided to users and any new releases, modifications, and enhancements thereto, belong solely to us or our licensors, if any, including all intellectual property rights therein. The App is licensed to you, not sold. Except as provided in these Terms, you shall not obtain any rights, title or interests in them, and shall not modify, copy, rent, lease, loan, sell, distribute or create derivative works based on them (either in whole or in part). There is no implied license, right or interest granted in any copyright, patent, trade secret, trademark, invention or other intellectual property right subsisting in the App and/or Services. We hereby expressly reserve all rights in the App and all Services, which are not expressly granted to you hereunder. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("4.2 License Grant")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Subject to your compliance with these Terms, we grant you a personal, limited, non-commercial, non-exclusive, non-sublicensable, non-assignable, revocable license to download, install and use, only on your personal computer or mobile device (the “Device”) for the sole purpose of your personal use of the App and any other applications that may be explicitly authorized by us for use through the App as permitted by these Terms. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("4.3")]),
        _vm._v(
          " By uploading, submitting, posting, displaying or otherwise providing Content on or through the Products, you grant us and our affiliates a worldwide, non-exclusive, royalty-free, unlimited, sub-licensable and transferable license to use, host, store, edit, perform, broadcast, rent, copy, reproduce, process, adapt, modify, publish, transmit, display and distribute such Content in any and all media or distribution methods now known or later developed (for clarity, these rights include, for example, curating, transforming, and translating). This license authorizes us to make your Content available to others who may do the same. You agree that this license includes the right for us to provide, promote, and improve the Products and to make Content submitted to or through the Products available to other users, companies, organizations or individuals for the broadcast, distribution, promotion or publication of such Content on other media and services – for example our Apps and Services, subject to our terms and conditions for such Content use. Such additional uses by us, or other companies, organizations or individuals, is made with no compensation paid to you with respect to the Content that you, transmit or otherwise make available through the Products as the use of the Products by you is hereby agreed as being sufficient compensation for the Content and grant of rights herein. In addition, in order for us to prevent illegal use of your Content outside our Products (if applicable), you agree to authorize us to act on your behalf against any infringement with respect to your Content in the App by users or other third parties. If your Content contains personal data, your license to us and our affiliates is subject to your rights granted by applicable laws regarding personal data protection. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("4.4 License Restrictions"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Unless applicable law expressly provides you with the right to do so, you shall not, and you shall not permit anyone else to, directly or indirectly: "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " · 1. copy, modify, adapt (including using in a collection), translate into any language, perform, communicate with public via tools transmitting signs, audio and visuals, distribute, or create derivative works based on the App or any of the Services; "
        ),
      ]),
      _c("div", [
        _vm._v(
          " · 2. sublicense, sublease, lease, lend, assign, sell, license, distribute, rent, export, re-export or grant other rights in the App or Service to any third party, and any attempt by you to take such action shall be void; "
        ),
      ]),
      _c("div", [
        _vm._v(
          " · 3. decompile, disassemble, reverse engineer, or attempt to reconstruct, identify, or discover any source code, underlying ideas, underlying user interface techniques, database or algorithms of the Products by any means whatsoever; "
        ),
      ]),
      _c("div", [
        _vm._v(
          " · 4. remove, obscure or alter any copyright and/or other proprietary notices or any contents thereof contained on or in or otherwise connected to the App or any of the Services; "
        ),
      ]),
      _c("div", [
        _vm._v(
          "· 5. use the Products to create or proliferate any virus or to circumvent any copy protection or other digital rights management mechanism;"
        ),
      ]),
      _c("div", [_vm._v("· 6. use the Products for any commercial purposes.")]),
      _c("div", { staticClass: "tit" }, [_vm._v("5. Content and Behaviour")]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("5.1 Prohibited behaviour"),
      ]),
      _c("div", { staticClass: "passage" }, [_vm._v("You may not:")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "· 1. use the Products for any illegal or unauthorized purpose;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· 2. use the Products to commit any acts in violation of applicable laws, regulations, rulings, decisions, orders of the court and/or administrative measures;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· 3. use the Products in any manner which could damage, disable, overburden or impair the App or any of the Services;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· 4. use the Products to transmit worms, viruses or any code of a destructive or malicious nature;"
        ),
      ]),
      _c("div", [
        _vm._v(
          " · 5. display, transmit or share any content consisting of text, sounds, audio, pictures, photos, video and/or any type of materials, information or communications (“Content”) deemed by us to be hateful, threatening, pornographic, obscene, abusive, racially or ethnically offensive, libelous or defamatory, or any Content that exhibits physical violence or encourages conduct that would be considered a criminal offense or bring forth civil liability, or any Content that undermines, or are likely to undermine, public order or moral customs; "
        ),
      ]),
      _c("div", [
        _vm._v(
          " · 6. attempt to hack, destabilize or adapt our website, the App (or its source code) or any of the Services, or to falsely imply that another website, app or service is affiliated with our Products; "
        ),
      ]),
      _c("div", [
        _vm._v(
          "· 7. use or access the Products by any means other than through the interface provided or as required by us."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.2")]),
        _vm._v(
          " Prohibited behaviours are further described in our Community Guidelines. Everyone using the App is expected to follow the guidelines. This includes that you are only allowed to use photos of yourself for your profile picture, that you may never lie about your age and that you may not try to impersonate someone else’s identity or create fake profiles in any other way. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.3")]),
        _vm._v(
          " Choosing to share your information in the App such as photos, texts, screenshots, videos and other communications in the App with other users, you agree that you may no longer be able to control how that information is used and that it may become publicly available (depending in part on your actions or the actions of the other users with whom you have shared the information). It is also possible that we may not be able to delete or remove user information if another user chooses to take copies and distribute them. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.4")]),
        _vm._v(
          " Failure to comply with the Community Guidelines or these Terms may result in your account being suspended or deactivated."
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("5.5 Your Content – be careful with what you share"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You are solely responsible for any Content that you transmit or display through the App or Services. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.6")]),
        _vm._v(
          " When you transmit or display Content through the App or Services, you grant us an unconditional, non-exclusive, royalty-free worldwide license to use, reproduce, transmit, publish, display, distribute or otherwise use this Content in the context of the App, the Services and promotion of the Products. You may revoke this license by deleting the Content from the App or Services. This does not affect any use of the Content by us prior to the revocation. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.7")]),
        _vm._v(
          " You may not display any personal contact or banking information on your individual profile page, or anywhere else on the App or Service, whether in relation to you or any other person (for example: home addresses or postcodes, telephone numbers, email addresses, URLs, credit/debit card or other banking details). If you do choose to reveal any personal information about yourself to other users, whether via email or otherwise, you acknowledge that you do so at your own risk. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.8")]),
        _vm._v(
          " If you share Content that is protected by intellectual property rights, you represent and warrant that you are the creator and owner of or have the necessary rights to transmit, display, perform or adapt the Content and you agree to pay for all royalties, fees, and any other monies owed to any person by reason of any of your Content. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.9")]),
        _vm._v(" The Content you transmit, display, perform or adapt may not:"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " ·1. infringe, violate, or misappropriate any third-party right, including any copyright, trademark, patent, trade secret, moral right, privacy right, right of publicity, or any other intellectual property or proprietary right, "
        ),
      ]),
      _c("div", [_vm._v("·2. be incorrect or misleading;")]),
      _c("div", [
        _vm._v(
          "·3. slander, defame, libel, or invade the right of privacy, publicity or other property rights of any other person"
        ),
      ]),
      _c("div", [
        _vm._v(
          " ·4. contain violent expressions, explicit sexual expressions, discriminatory expressions concerning race, nationality, belief, gender, social status, etc., or expressions that entice or promote suicide, self-harm, drug abuse, and other expressions that contain anti-social content and are offensive to others. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.10")]),
        _vm._v(
          " If you do not comply with the above, you may be subject to criminal and civil liability and we have a right to immediately (permanently or temporarily) terminate your account and/or delete or make unavailable (all or part of) the relevant Content. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _c("i", { staticClass: "num" }, [_vm._v("5.11")]),
        _vm._v(" Other Users’ Content"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Although this is not allowed under our Community Guidelines and these Terms, you understand and acknowledge that the Content, including but not limited to information regarding personal and physical appearance, transmitted, displayed or communicated by other users through the Products may be incorrect, misleading, or edited electronically in a manner that does not accurately represent such user’s actual information or physical appearance, or may violate your or third parties’ personal or intellectual property rights. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("6. Your data")]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("6.1")]),
        _vm._v(
          " We process and store your data in compliance with our Privacy Policy."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("6.2")]),
        _vm._v(
          " You understand that we can use carrier distributed mobile messaging (SMS) to verify ownership of registered mobile phone numbers in relation to the users of the App or Services. We use carrier distributed mobile messaging for verification purposes and we will do so only in accordance with our Privacy Policy. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("6.3")]),
        _vm._v(
          " We will use reasonable efforts to store or otherwise retain your Content in relation to the Products."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("6.4")]),
        _vm._v(
          " You can choose to provide comments, suggestions, or feedback relating to the Products (the “Feedback”) to us through the Feedback submission channels provided to you or the “review” pages of Google Play Store or Apple App Store or other application stores (collectively, the “Application Stores”). You agree that we will have an exclusive license to all rights to the Feedback and will be entitled to use the Feedback for any commercial or other purpose whatsoever, without any compensation or attribution to you or any other person. We will not be required to treat any Feedback as confidential. You agree that you do not acquire any right in or to the Products (or any changes, modifications or corrections thereto) by virtue of any Feedback. You also acknowledge that you are responsible for whatever material is submitted by you, including its legality, reliability, appropriateness, originality, and copyright. "
        ),
      ]),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div", { staticClass: "tit" }, [
        _vm._v("7. Premium Services, Paid Content, Loyalty Programme"),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("7.1 Premium Services and other Paid Content and items"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " From time to time, we may provide additional features and/or Services that you request and pay for (“Premium Services”). We may also offer from time to time in our sole discretion, certain Premium Services and certain paid Content and items as part of the Products for free, whether for a trial period or otherwise. Unless expressly stated otherwise, references made in these Terms to the “Services” shall include the Premium Services and all types of paid Content and items offered under the Services. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.2")]),
        _vm._v(
          " Any payment for the Premium Services and any paid Content and items offered under the App or Services that you purchase will first be made using the paid coins that you have purchased via the App. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.3")]),
        _vm._v(
          " Subject to our sole discretion, the Premium Service and paid Content and items under the App or Services may be offered either on a subscription basis, per usage basis or as otherwise described at the time of your purchase, and may be payable either in advance, in arrears, per usage, or as otherwise described at the time of your purchase. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.4")]),
        _vm._v(
          " If you purchase any Premium Service and/or any paid Content and items offered under the Services or App, you hereby agree to pay all charges to your account, including all applicable taxes and transaction costs, in accordance with our standard billing terms in effect at the time the charges are payable, regardless of whether such costs are charged by the Application Stores. Before your purchase, the full and final price of any Premium Service and/or any paid Content will be displayed. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.5")]),
        _vm._v(
          " You agree to abide by any relevant third parties’ terms of service or other legal agreements that govern your use of a given payment processing service and/or method in relation to the App or Services. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.6")]),
        _vm._v(
          "If you purchase Premium Services and/or any paid Content and items under the Services on a subscription basis, you acknowledge and agree that payments will be made on a recurring basis and by the payment method and payment intervals you have selected, until such subscription for Premium Services and/or paid Content and items is terminated. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.7")]),
        _vm._v(
          " You agree that if you purchase Premium Services and/or any paid Content and items through an Application Store, all payment related questions, issues, disagreements and/or disputes regarding that transaction with an Application Store shall be handled in accordance with the terms of service or other legal agreement that governs your use of a given payment processing service and/or method, and in no event will we have any responsibility in connection with any of the foregoing. You shall indemnify and hold us harmless from any Application Stores’ claims as mentioned under this paragraph, even if a court or administrative agency decides that we are be liable for such question, issue, disagreement or dispute. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("7.8 Refunds")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " When you purchase any Premium Service and/or any paid Content or item, you purchase digital content that we supply. Before you make the purchase, you consent to us immediately performing the Service or delivering the Content or item after your purchase. As a consequence of this consent, you can no longer request a refund for that particular Service, Content or item based on your right to withdraw from a consumer purchase. The following Articles 7.10 and 7.11 only apply in a situation where you made a purchase without giving consent to immediately perform the Service or deliver the Content of the item. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.9")]),
        _vm._v(
          " You may request a full refund for any Premium Service and/or any paid Content and item purchased from an Application Store if permitted by, and pursuant to the refund rules of the Application Store, subject to the following exceptions: (1) refunds are not available to users who are banned by us and/or its community; and (2) refunds are not available for partially used purchases. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.10")]),
        _vm._v(
          " You may request a refund for any Premium Service and/or any paid Content and item purchased outside of the Application Store within 14 days of purchase by contacting our customer service (see contact details at Article 1.2 above) or by filling in the form attached to these Terms, subject to the following exceptions: (1) refunds are not available if they are not permitted by payment channels and/or platforms; and (2) full refunds are not available for partially used purchases. You acknowledge that, upon a successful request, your money will be refunded in the same manner you used to make the original payment. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("7.11 Loyalty Programme")]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.11.1")]),
        _vm._v(
          " As part of your use of the App and the Services you are automatically part of the App loyalty programme, which rewards you for your use of the Services according to the loyalty programme terms. You will receive updates regarding your loyalty programme rewards via the Loyalty program notification. You will also see the loyalty programme rewards in your account in the App. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.11.2")]),
        _vm._v(
          " The loyalty programme will send to you notifications only about your rewards."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("7.11.3")]),
        _vm._v(
          " The loyalty programme may be changed, amended or canceled by us at anytime and in our sole discretion."
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("8. Third Parties")]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("8.1 Third Party technology"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " The App may be incorporated into, and may itself incorporate, software and other technology owned and controlled by third parties. Any such third-party software or technology that is incorporated in the App falls under the scope of these Terms. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("8.2 Third Party Fees")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " For particular Devices, we may ask for your permission to use your native SMS application to deliver messages or invitations to people who are not registered users of the Products and with whom you choose to communicate. Some of these services may charge additional fees, which shall be incurred solely at your own cost and risk. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("9. Termination")]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("9.1 Termination by you")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You may terminate your use of the App and/or Services at any time by deleting your account. You can delete your account within the App. The path to delete your account: find “Me” > then select “Setting” > then choose “Account Settings” > then click on “Delete Account”. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("9.2 Termination by us")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Without limiting any other remedies, we may limit, suspend, discontinue or terminate these Terms, your account and/or your use of all or any part of the App and/or Services, your Content on the App and/or Services, or reclaim your usernames, with immediate effect, automatically, if we believe that you are or may be: "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v("· 1. in breach of any of the terms of these Terms;"),
      ]),
      _c("div", [
        _vm._v(
          "· 2. causing, or threatening to cause us to incur any legal liabilities (actual or potential);"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· 3. delinquent with respect to any charges due for a Premium Service and/or any paid Content and items;"
        ),
      ]),
      _c("div", [
        _vm._v(
          "· 4. infringing a third party’s intellectual property rights or personal rights or performing any forbidden activity listed under Article 4.4; or"
        ),
      ]),
      _c("div", [
        _vm._v(
          " · 5. engaging in prohibited behaviours listed under Article 5.1, including but not limited to child abuse, prostitution, pornography, discrimination based on age, sex, gender, ethnicity, nationality, profession, political stance, religion, scamming, consumption of illegal drugs or substances. You acknowledge and agree that we will not be liable with regard to such limitation, suspension and termination of these Terms, your account and your use of all or any part of our Products under the above mentioned circumstances. We will notify you without delay of the reasons for any such limitation, suspension or termination of these Terms, your use of our Products or your Content, except in the event that the notification is not permitted under applicable laws, regulations and policies (including without limitation, a regulatory authority’s order, a regulatory investigation) or we reasonably determines that such notification may result in damage to the users, third parties, or us (e.g., if it impairs the security of our Products). "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("9.3 Consequences of termination"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " In case of termination of your account by you or by us, for whatever reason, your license to use the Service will immediately end and any Premium Service you may have subscribed to will also end and any paid Content you may have in your account will be deleted. After termination of your account, you will not be entitled to a refund for any paid Content or Premium Services that were connected to your account prior to termination. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("9.4")]),
        _vm._v(
          " If you have subscribed to any Premium Service and/or any paid Content, you agree that you are solely responsible for directly terminating all payment obligations you may have with any Application Store and/or payment processing service in connection with such Premium Service and/or paid Content before deleting your account. Any and all liabilities that occur as a result of your failure to do so will be at your own cost and risk. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("10. Liability")]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("10.1")]),
        _vm._v(
          " We are not liable for any damages based on your use of the App or the Services, your ability to use the App or the Services or in any way or for any failures in the App or Services. Your access to and use of the Services and App or any content is at your own risk. You understand and agree that the Services are provided to you on an “As Is” and “As Available basis”. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("10.2")]),
        _vm._v(
          " If we are liable for any event, this liability shall be limited to direct damages. This means that we are not liable for, among other things, any consequential, indirect or reputational damages, any loss, deletion, destruction or damage of or to your personal rights, your data, your personal data or your device. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("10.3")]),
        _vm._v(
          " As some jurisdictions do not allow the enforcement of some of the exclusions or limitations set forth in these Terms, some of these exclusions or limitations may not apply to you. In such an event, our liability will be limited to the maximum extent possible under applicable law. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("10.4")]),
        _vm._v(
          " Any limitations of liability as set out above do not apply insofar as the damage has resulted from willful misconduct or gross negligence on our part. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("11. Indemnification")]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("11.1")]),
        _vm._v(
          " You hereby agree to indemnify defend and hold us harmless, as well as our licensors, partners, and our respective affiliates, officers, directors, employees, contractors and suppliers (individually and collectively ), from and against any and all claims, actions, liability, damages and costs, including reasonable attorneys’ fees incurred by such parties, in connection with or arising out of: "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          "· a). your violation or breach of any term of these Terms or any applicable law or regulation, whether or not referenced herein;"
        ),
      ]),
      _c("div", [
        _vm._v("· b). your violation of any rights of any third party;"),
      ]),
      _c("div", [_vm._v("· c). your use or misuse of the Products; or")]),
      _c("div", [
        _vm._v(
          "· d). your Content or other communication displayed or transmitted by means of the Products."
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("11.2")]),
        _vm._v(
          " The above indemnification applies even if a court, an administrative agency or any other dispute resolving or investigating body decides we shall be held liable and/or imposes sanction on us. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("11.3")]),
        _vm._v(
          " If you downloaded the App from the Application Stores, you acknowledge that, if there is a claim by any third party that the Products or your possession and use of the Products infringes any intellectual property rights, only we are responsible for the investigation, defense, settlement and discharge of such claim. We can exclusively defend and control any matter for which you indemnify us, at your expense. You agree to cooperate with our defense of these claims, and you will not settle any matter without our prior written consent. "
        ),
      ]),
      _c("div"),
      _c("div", { staticClass: "tit" }, [_vm._v("12. Warranties")]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("12.1")]),
        _vm._v(
          " The Products are provided to you “as is” and “as available” with no warranties. We hereby, to the fullest extent possible, disclaim all warranties, terms, or conditions, express or implied, either in fact or by operation of law, statutory or otherwise, including, without limitation, warranties, terms or conditions of merchantability, fitness for a particular purpose, satisfactory quality, correspondence with description, title, non-infringement, and accuracy of information generated. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("12.2")]),
        _vm._v(
          " We do not warrant that the Content displayed or transmitted on or through the Products will be uninterrupted, or free of errors, viruses or other harmful components, and do not warrant that any of the foregoing will be corrected. We do not warrant or make any representations regarding the use of, or the results from the use of, the App or Services. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("12.3")]),
        _vm._v(
          " Accordingly, you acknowledge and agree that we (and any Application Stores from which you downloaded the App) will have no liability in connection with or arising from your use of the App and/or any of the Services. Your only right or remedy with respect to any problems or dissatisfaction with the App and/or any of the Services is to immediately uninstall the App and cease use of the App and all Services. You further acknowledge that we (and Apple or Google, as providers of Application Stores, where relevant) have no obligation whatsoever to provide any maintenance or support services with respect to the App and/or Services. "
        ),
      ]),
      _c("div", { staticClass: "tit" }, [_vm._v("13. General")]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("13.1 Device errors")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We do not guarantee the validity or compatibility of the App and/or Services to your device and we are not responsible for your damages and losses which arose due to faults, bugs, troubles on your Device, App, information systems, online access point and network, errors of design, interface, linking, virus infection, disconnection from network, power outages and voltage volatility, regardless of whether such damages and losses were foreseeable or advised to us. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("13.2 Claims")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " If you downloaded the App from the Application Stores, you acknowledge that the providers of those Application Stores shall have no responsibility for addressing any claims relating to the Products or your possession and/or use of the App or Services, including, but not limited to: (i) product liability claims; (ii) any claim that the Products fail to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection or similar legislation, without prejudice to this Article 10. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("13.3 Basis of Bargain")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You acknowledge and agree that we have offered the App and/or Services and set its prices in reliance upon the warranty disclaimers and the limitations of liability set forth herein, that the warranty disclaimers and the limitations of liability set forth herein reflect a reasonable and fair allocation of risk between you and us, and that the warranty disclaimers and the limitations of liability set forth herein form an essential basis of the bargain between you and us. We would not be able to provide the Products to you on an economically reasonable basis without these limitations. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("13.4 Notices")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We may provide you with notices by email, notifications through the App or posts on our website. For notices provided via emails, such notice will be deemed to be given twenty-four (24) hours after the email is sent. You are responsible for providing us with your accurate contact details at all times. Notice provided through the App shall be deemed to be given at the time you read or view it. Notice posted on our website shall be deemed to be given ten (10) days following the initial posting. We reserve the right to determine the form and means of providing notifications to the users. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("13.5 Amendments")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " We reserve the right to amend the Terms at any time as we deems necessary to the maximum extent permitted by relevant laws and regulations. We will publish the revised Terms on our website and provide notice of such amendment by email or a notification through the App. The revised Terms shall become effective following the applicable notice period unless you expressly accept the revised Terms earlier by clicking on the accept button (where relevant). Your express acceptance or continued use of the Products after the applicable notice period shall constitute your acceptance to be bound by the terms and conditions of the revised Terms. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("13.6 Assignment")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You are not allowed to assign these Terms or any rights or obligations hereunder. We are allowed at our sole discretion to assign these Terms and any rights hereunder to any third party, in accordance with procedures set forth in relevant laws and regulations, and you hereby provide your consent to such assignment. In case of assignment to a third party, you are allowed to terminate your use of the Services and App by deleting your account. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("13.7 Entire Agreement and Severability"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " These Terms and our other policies mentioned herein represent the complete agreement concerning the matters covered between you and us. These Terms may be amended only in writing executed by both parties, except as set forth under Amendments (Article 13.5) above. If any provision of these Terms is held to be unenforceable, such provision shall be modified only to the extent necessary to make it enforceable and shall not affect the enforceability or validity of the remaining provisions, which shall remain in full force and effect. "
        ),
      ]),
      _c("div", { staticClass: "passage" }, [
        _c("i", { staticClass: "num" }, [_vm._v("13.8")]),
        _vm._v(
          " The provisions referred to in these Terms apply to the extent that such are permitted under applicable law. In the event that certain provisions are not permitted, those provisions shall not apply to you, while the other provisions shall continue to apply. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("13.9 Waiver")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " Should we not exercise or enforce any right or provision of these Terms, this will not constitute a waiver of such right or provision. Any waiver of any provision of these Terms will be effective only if in writing and signed by us. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [_vm._v("13.10 Headings")]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " The heading references used in these Terms are for convenience purposes only and do not constitute a part of the Terms and will not be deemed to limit or affect any of the provisions hereof. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("13.11 Injunctive Relief"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " You acknowledge that the obligations you agree to undertake with these Terms are of a unique and irreplaceable nature, and that failure to comply with them shall irreparably harm us and that such failure cannot be compensated by monetary damages alone so that we shall be entitled to injunctive or other equitable relief if it is available under the applicable law (without the obligations of posting any bond or surety) in the event of any breach or anticipatory breach by you. "
        ),
      ]),
      _c("div", { staticClass: "tit-tow" }, [
        _vm._v("13.12 Legal Jurisdiction"),
      ]),
      _c("div", { staticClass: "passage" }, [
        _vm._v(
          " This Agreement shall be governed by and construed in accordance with the laws of Hong Kong, without regard to choice of law principles. Any dispute arising out of or in connection with this Agreement, including any question regarding its existence, validity or termination, shall be referred to and finally resolved by arbitration administered by the Hong Kong International Arbitration Centre in accordance with the Arbitration Rules of the Hong Kong International Arbitration Centre for the time being in force, which rules are deemed to be incorporated by reference in this clause. The seat of the arbitration shall be Hong Kong. The language of the arbitration shall be English. To make a request, please go here. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }